import React from 'react';
import {
  CircularProgress, Typography, Button, Grid, Hidden, TextField, Box,
} from '@material-ui/core';
import useForm from 'utils/hooks/useForm';
import imagePerson from '../../../../commons/assets/images/bannerPersonPasswordGeneration.png';

const UpdatePasswordForm = (props) => {
  const {
    classes, onChangeText, controls, password, verifyPassword, loading, actions,
  } = props;

  const { onChange, onSubmit, errors } = useForm(controls, null, {
    onChange: onChangeText,
    validations: {
      password: [
        {
          check: (value) => !!value,
          message: 'La contraseña es requerida',
        },
        {
          check: (value) => value != null && value.trim().length >= 6 && value.trim().length < 20,
          message: 'La contraseña debe tener entre 6 y 20 caracteres',
        },
        {
          check: (value) => value != null && (/^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*)$/).test(value) === true,
          message: 'La contraseña debe tener al menos una mayúscula y un número',
        },
      ],
      verifyPassword: [
        {
          check: (value) => !!value,
          message: 'La verificación de contraseña es requerida',
        },
        {
          check: (value) => value === password,
          message: 'Las contraseñas deben coincidir',
        },
      ],
    },
  });

  const onClickUpdatePassword = (event) => {
    event.preventDefault();
    onSubmit(() => actions.updatePassword(controls));
  };

  const handleChange = (event) => {
    event.preventDefault();
    onChange(event);
  };

  return (
    <div>
      <Grid container justifyContent="center" alignItems="center">
        <Hidden mdUp>
          <Grid item xs={12}>
            <img
              src={imagePerson}
              className={classes.imagePerson}
              alt="imagePeron"
            />
          </Grid>
        </Hidden>
        <Grid item lg={4} md={5} xs={12}>

          <form onSubmit={onClickUpdatePassword}>

            <Grid container>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center">
                  <Box className={classes.item}>
                    <Typography variant="caption" color="primary" noWrap>
                      <Box className={classes.customTitle}>Generar contraseña</Box>
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center">
                  <Box className={classes.item}>
                    <TextField
                      className={classes.field}
                      label="Nueva contraseña"
                      key="password"
                      id="password"
                      type="password"
                      variant="outlined"
                      name="password"
                      value={password}
                      onChange={handleChange}
                      fullWidth
                      error={errors.password}
                      helperText={errors.password && errors.password[0]}
                    />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center">
                  <Box className={classes.item}>
                    <TextField
                      className={classes.field}
                      label="Repita su nueva contraseña"
                      key="verifyPassword"
                      id="verifyPassword"
                      name="verifyPassword"
                      type="password"
                      variant="outlined"
                      value={verifyPassword}
                      onChange={handleChange}
                      autoFocus
                      fullWidth
                      error={errors.verifyPassword}
                      helperText={errors.verifyPassword && errors.verifyPassword[0]}
                    />
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                className={classes.customHint}
              >
                <Box display="flex" justifyContent="center">
                  <Box className={classes.item}>
                    <Typography variant="caption" color="primary">
                      <Box>
                        La contraseña debe tener un mínimo de 8 caracteres.
                      </Box>
                      <Box>
                        Debe contener al menos una letra mayúscula y un número
                      </Box>
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="center">
                  <Box className={classes.item}>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      color="secondary"
                      className={classes.button}
                    >
                      {loading ? (
                        <CircularProgress className={classes.progress} />
                      ) : (
                        'GENERAR'
                      )}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Grid>
        <Grid
          item
          lg={8}
          md={7}
        >
          <div className={classes.divPassword}>
            <Hidden smDown>
              <Typography className={classes.imageOverlayTextGeneratePassword} color="primary" variant="h6">
                <p className={classes.paragraph}>Expertos en mantener </p>
                <p className={classes.paragraph}>tu flota operacional</p>
              </Typography>
            </Hidden>
          </div>
          <Hidden smDown>
            <img
              src={imagePerson}
              className={classes.bannerPerson}
              alt="imagePerson"
            />
          </Hidden>
        </Grid>

      </Grid>

    </div>

  );
};

export default UpdatePasswordForm;
